import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, styled } from '@mui/material';

export const GanttBox = styled(Box)`
    display: flex;
    z-index: 1;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: auto;
`;
export const GanttContentBox = styled(Box)`
    position: relative;
    // Allows the grid to take all the available space OR exaclty the gantt content :
    max-height: fit-content;
    height: 100000px;
    pointer-events: none; // allow cursor hover to pass through to OverCapacity alerts
    margin-top: 10px;
`;
export const GanttTurnaroundsRowBox = styled(Box)`
    top: 0;
    display: flex;
    flex-direction: column;
    width: 100%; // allow dragged flights to overflow
    min-width: 100%;
    min-height: 50px;
    overflow: hidden;
    pointer-events: all;
`;
export const StyledPlayArrowIcon = styled(PlayArrowIcon)`
    transform: rotate(90deg);
    color: white;
    width: 15px;
    height: 15px;
    position: absolute;
    left: -7.5px;
    top: 18px;
`;
export const StyledCurrentTimeIndicator = styled(Box)`
    position: absolute;
    margin-top: 15px;
    height: 100%;
    background-color: white;
    width: 1px;
    overflow: visible;
`;
